import { Injectable } from '@angular/core';
import { readFromStorage, writeToStorage } from '../utils/local-storage.utils';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TenantFavsService {
    readonly tenantFavsStorageKey = 'CDP_TENANT_FAVS';
    public get favsUpdated$(): Observable<void> {
        return this.favsUpdatedSubject.asObservable();
    }
    private favsUpdatedSubject = new Subject<void>();

    getTenantFavs(): string[] {
        return readFromStorage(this.tenantFavsStorageKey) || [];
    }

    setTenantFavs(tenantFavs: string[]): void {
        writeToStorage(this.tenantFavsStorageKey, tenantFavs);
    }

    addTenantFav(tenantId: string): void {
        const tenantFavs = this.getTenantFavs();
        if (!tenantFavs.includes(tenantId)) {
            this.setTenantFavs([...tenantFavs, tenantId]);
        }
        this.favsUpdatedSubject.next();
    }

    removeTenantFav(tenantId: string): void {
        const tenantFavs = this.getTenantFavs();
        this.setTenantFavs(tenantFavs.filter(fav => fav !== tenantId));
        this.favsUpdatedSubject.next();
    }
}
